import React from 'react';
import { MessageCircle } from 'lucide-react';
export function WhatsAppButton() {
  return <a href="https://wa.me/447921876472?text=Hello%20Nexora%20Virtual" target="_blank" rel="noopener noreferrer" className="fixed bottom-8 right-8 z-50 group" aria-label="Chat on WhatsApp" data-id="element-127">
      <div className="absolute inset-0 bg-[#25D366] rounded-full animate-pulse-custom opacity-70" data-id="element-128"></div>
      <div className="relative bg-[#25D366] text-white p-4 rounded-full shadow-xl hover:bg-[#20bd5a] transition-colors flex items-center justify-center" data-id="element-129">
        <MessageCircle size={32} fill="white" data-id="element-130" />
      </div>

      {/* Tooltip */}
      <div className="absolute right-full mr-4 top-1/2 -translate-y-1/2 bg-white px-4 py-2 rounded-lg shadow-lg text-sm font-bold text-gray-800 whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity pointer-events-none" data-id="element-131">
        Chat with us!
        <div className="absolute right-[-6px] top-1/2 -translate-y-1/2 w-3 h-3 bg-white transform rotate-45" data-id="element-132"></div>
      </div>
    </a>;
}